module.exports = __webpack_public_path__ + "static/media/brain.dbcb9413.svg";